import {
  Component,
  Injector,
  ViewEncapsulation,
  ViewChild,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ActivitiesServiceProxy,
  ActivityDaysServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { NotifyService } from 'abp-ng2-module';
import { AppComponentBase } from '@shared/common/app-component-base';
import { TokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';

import { appModuleAnimation } from '@shared/animations/routerTransition';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-cancel-allocation-modal',
  templateUrl: './cancel-allocation-modal.component.html',
  styleUrls: ['./cancel-allocation-modal.component.less'],
  encapsulation: ViewEncapsulation.None,
  animations: [appModuleAnimation()],
})
export class CancelAllocationModalComponent
  extends AppComponentBase
  implements OnInit {
  cancelReason: string;
  saving = false;
  step: 1 | 2 = 1;
  override = false;

  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('cancelAllocationModal', { static: true }) modal: ModalDirective;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {}

  close() {
    this.modal.hide();
  }

  cancelAllocation() {
    this.saving = true;

    this.onCancel.emit({
      override: this.override,
      reason: this.cancelReason,
    });
  }
}
